<div fxLayout="row" *ngIf="element">
  <form fxFlex="100">
    <mat-form-field fxFlex="100" appearance="standard">
      <mat-label *ngIf="label">{{ 'status' | translate }}</mat-label>
      <mat-select [formControl]="form">

        <!-- Current value -->
        <mat-select-trigger>
          <!-- <mat-icon [style.color]="status.color">label</mat-icon> -->
          <span class="value">{{ status.displayName }}</span>
        </mat-select-trigger>

        <!-- Dropdown -->
        <mat-option *ngFor="let status of statuses" [value]="status._id" (click)="setStatus(status._id)">
          <mat-icon [style.color]="status.color">label</mat-icon>
          {{ status.displayName }}
        </mat-option>

      </mat-select>
    </mat-form-field>
  </form>      
</div>
